import React, { useEffect } from "react";
import "./bottomBar.css";
import { Link, useLocation } from "react-router-dom";
import CardGiftcardRounded from "@mui/icons-material/CardGiftcardRounded";
import AutoAwesomeRounded from "@mui/icons-material/AutoAwesomeRounded";
import MilitaryTechRounded from "@mui/icons-material/MilitaryTechRounded";
import LeaderboardIcon from "../../assets/icon/LeaderBoard.svg";
// import WinnersIcon from 
import ProfileIcon from "../../assets/icon/Profile.svg";

const TAB_ROUTES = [
  {
    tab: "special",
    paths: ["/bonus-questions"],
  },
  {
    tab: "predictions",
    paths: ["/", "/home"],
  },
  {
    tab: "leaderboard",
    paths: ["/mobile-leaderboard"],
  },
  {
    tab: "profile",
    paths: [
      "/mobile-profile",
      "/mobile-login",
      "/mobile-register",
      "/mobile-forgot-password",
      "/mobile-support",
      "/mobile-settings",
      "/mobile-user-profile",
      "/mobile-prizes",
      "/mobile-terms-conditions",
    ],
  },
];

const getActiveTabFromPath = (pathname) => {
  const match = TAB_ROUTES.find((route) => route.paths.includes(pathname));
  return match ? match.tab : "predictions";
};

const BottomBar = () => {
  const location = useLocation();
  const activeTab = getActiveTabFromPath(location.pathname);

  return (
    <div className="bottomBar">
      <div className="bottomBar-wrapper">
        <div className="bottomBar-content">
          <div className="bottom-special-wrapper">
            <Link to="/bonus-questions">
              <div
                className={
                  activeTab === "special"
                    ? "bottom-special bottom-special-selected"
                    : "bottom-special"
                }
              >
                <div className="specialImg">
                  {/* <span className="bottom-special-newTag">New</span> */}
                  <CardGiftcardRounded className="special-icon" />
                </div>
                <p c className={
                  activeTab === "special"
                    ? "special-title-selected"
                    : "special-title"
                }>Bonus Questions</p>
              </div>
            </Link>
          </div>

          {/* <div className="bottom-predict-wrapper">
            <Link to="/">
              <div className="bottom-predict">
                <div className="predictImg">
                  <img
                    className={
                      activeTab === "predictions" ? "svg-icon-selected" : "svg-icon"
                    }
                    src={PredictionIcon}
                    alt=""
                  />
                </div>
                <p
                  className={
                    activeTab === "predictions"
                      ? "option-title-selected"
                      : "option-title"
                  }
                >
                  Predictions
                </p>
              </div>
            </Link>
          </div> */}
              <div className="bottom-predict-wrapper">
            <Link to="/mobile-winners">
              <div className="bottom-predict">
                <div className="predictImg">
                  <MilitaryTechRounded
                    className={
                      activeTab === "predictions" ? "svg-icon-selected" : "svg-icon"
                    }
                  />
                </div>
                <p
                  className={
                    activeTab === "predictions"
                      ? "option-title-selected"
                      : "option-title"
                  }
                >
                  Winners
                </p>
              </div>
            </Link>
          </div>

          <div className="bottom-leaderboard-wrapper">
            <Link to="/mobile-leaderboard">
              <div className="bottom-leaderboard">
                <div className="leaderboardImg">
                  <img
                    className={
                      activeTab === "leaderboard" ? "svg-icon-selected" : "svg-icon"
                    }
                    src={LeaderboardIcon}
                    alt=""
                  />
                </div>
                <p
                  className={
                    activeTab === "leaderboard"
                      ? "option-title-selected"
                      : "option-title"
                  }
                >
                  Leaderboard
                </p>
              </div>
            </Link>
          </div>

          <div className="bottom-profile-wrapper">
            {localStorage.webKey ? (
              <Link to="/mobile-profile">
                <div className="bottom-profile">
                  <div className="profileImg">
                    <img
                      className={
                        activeTab === "profile" ? "svg-icon-selected" : "svg-icon"
                      }
                      src={ProfileIcon}
                      alt=""
                    />
                  </div>
                  <p
                    className={
                      activeTab === "profile"
                        ? "option-title-selected"
                        : "option-title"
                    }
                  >
                    Profile
                  </p>
                </div>
              </Link>
            ) : (
              <Link to="/mobile-login">
                <div className="bottom-profile">
                  <div className="profileImg">
                    <img
                      className={
                        activeTab === "profile" ? "svg-icon-selected" : "svg-icon"
                      }
                      src={ProfileIcon}
                      alt=""
                    />
                  </div>
                  <p
                    className={
                      activeTab === "profile"
                        ? "option-title-selected"
                        : "option-title"
                    }
                  >
                    Login
                  </p>
                </div>
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;